/**
 * 프로젝트/용역 관련 상수 정의
 */

import { InspectionType, ProjectStatus } from '../@types';

/** 점검 종류 목록 */
export const INSPECTION_TYPES: InspectionType[] = [
    '정기안전점검',
    '정밀안전점검',
    '정밀안전진단',
    '기타(직접입력)'
];

/** 프로젝트 상태 목록 */
export const PROJECT_STATUSES: ProjectStatus[] = [
    '대기',
    '진행중',
    '완료',
    '중단'
];

/** 상태별 스타일 매핑 */
export const STATUS_STYLES: Record<ProjectStatus, { bg: string; text: string }> = {
    '대기': { bg: 'bg-slate-600/20', text: 'text-slate-400' },
    '진행중': { bg: 'bg-blue-600/20', text: 'text-blue-400' },
    '완료': { bg: 'bg-emerald-600/20', text: 'text-emerald-400' },
    '중단': { bg: 'bg-red-600/20', text: 'text-red-400' }
};

/** 점검 종류별 스타일 매핑 */
export const INSPECTION_TYPE_STYLES: Record<string, { bg: string; text: string }> = {
    '정기안전점검': { bg: 'bg-slate-600/10', text: 'text-slate-400' },
    '정밀안전점검': { bg: 'bg-amber-600/10', text: 'text-amber-400' },
    '정밀안전진단': { bg: 'bg-blue-600/10', text: 'text-blue-400' }
};

/** 프로젝트 폼 초기값 */
export const INITIAL_PROJECT_FORM = {
    title: '',
    type: '',
    type_etc: '',
    participants: '',
    start_date: '',
    end_date: '',
    client: ''
};

/** 프로젝트 통계 초기값 */
export const INITIAL_PROJECT_STATS = {
    total: 0,
    diagnosis: 0,
    inspection_fine: 0,
    inspection_regular: 0
};
